<template>
  <div id="micBox">
    <div class="audioValBox" ref="audioValBox" :style="{background: background}">
      <div class="level" ref="level"></div>
    </div>
    <p class="line"></p>
    <div class="verticalDivider"></div>
    <div class="footLine"></div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import VolumeBar from '@/assets/js/volumeBar'
export default {
  data () {
    return {
      audioValBoxHeight: 0,
      audioContext: null,
      animationObj: null,
      level: 0
    }
  },
  computed: {
    ...mapState({
      State: state => state
    })
  },
  props: {
    audioTrack: {
      type: Object,
      default: function () {
        return {}
      }
    },
    rtilCode: {
      type: Number,
      default: 0
    },
    background: {
      type: String,
      default: ''
    }
  },
  watch: {
    level (newVal, oldVal) {
      // 这个地方取值取反，因为 UI 是从上往下算的高不是从下往上
      this.$refs.level.style.height = (100 - newVal.toFixed(2) * 100) + '%'
    }
  },
  mounted () {
    if (!this.State.volumeBar) {
      this.State.volumeBar = new VolumeBar()
    }
    this.audioValBoxHeight = this.$refs.audioValBox.clientHeight
    if (this.audioTrack && this.audioTrack._mediaStreamTrack) {
      this.State.volumeBar && this.State.volumeBar.addAudioTrack(this.rtilCode, this.audioTrack._mediaStreamTrack, (volumeLeft, volumeRight) => {
        const dbLeftVal = 20 * Math.log10(volumeLeft * 16)
        const dbRightVal = 20 * Math.log10(volumeRight * 16)
        const ampLeft = Math.max(dbLeftVal / 60 + 0.8, 0)
        const ampRight = Math.max(dbRightVal / 60 + 0.8, 0)
        this.level = ampLeft
        this.canvasDrap(this.rtilCode + 'Left', ampLeft)
        this.canvasDrap(this.rtilCode + 'Right', ampRight)
      })
    }
  },
  methods: {
    canvasDrap (id, data) {
      const canvas = document.getElementsByClassName(id)
      if (!canvas || canvas.length == 0) return
      if (canvas && canvas.length > 0) {
        for (let i = 0; i < canvas.length; i++) {
          const currentCanvas = canvas[i]
          const w = currentCanvas.clientWidth
          const h = currentCanvas.clientHeight
          const currentPercent = data
          const ctx = currentCanvas.getContext('2d')
          currentCanvas.width = w
          currentCanvas.height = h
          currentCanvas.style.transform = 'rotate(180deg)'
          // 填充渐变色, fillRect 是从左上角开始 即(0,0)坐标开始.
          // 因此注意,canvas显示的时候旋转 canvas 180度 是个好的解决方案
          const gradient = ctx.createLinearGradient(0, 0, 0, h)
          gradient.addColorStop(0, '#5DC045')
          gradient.addColorStop(0.29, '#5DC045')
          gradient.addColorStop(0.8, '#F1D737')
          gradient.addColorStop(1, '#F6445A')
          ctx.clearRect(0, 0, w, h)
          ctx.fillStyle = gradient
          ctx.fillRect(0, 0, w, currentPercent * h)
        }
      }
    }
  }
}
</script>
<style scoped lang="less">
#micBox {
  display: inline-block;
  position: relative;
  top: 1px;
  .audioValBox {
    width: 4px;
    height: 8px;
    border-radius: 38%;
    border: 2px solid #fff;
    margin: 0 auto;
    position: relative;
    .level {
      background: rgb(30,30,33);
      width: 100%;
    }
  }
  .line {
    border: 2px solid #fff;
    width: 10px;
    height: 7px;
    border-radius: 28px;
    border-bottom-right-radius: 50px;
    border-bottom-left-radius: 50px;
    border-top-color: transparent;
    margin: -8px auto 0;
  }
  .verticalDivider {
    width: 2px;
    height: 1px;
    background: #fff;
    margin: 0 auto;
  }
  .footLine {
    width: 8px;
    background: #fff;
    height: 2px;
    margin: 0 auto;
  }
}
</style>
